import script from "./AbnormalPreViewImg.vue?vue&type=script&lang=ts&setup=true"
export * from "./AbnormalPreViewImg.vue?vue&type=script&lang=ts&setup=true"

import "./AbnormalPreViewImg.vue?vue&type=style&index=0&id=5e9e664c&lang=scss"

const __exports__ = script;

export default __exports__